var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProspectsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.75 12C22.75 17.9277 17.9277 22.75 12 22.75C6.0723 22.75 1.25 17.9277 1.25 12C1.25 6.0723 6.0723 1.25 12 1.25C12.4141 1.25 12.75 1.5859 12.75 2V9.6272C13.7618 9.9473 14.5 10.8824 14.5 12C14.5 13.3807 13.3807 14.5 12 14.5C10.6193 14.5 9.5 13.3807 9.5 12C9.5 10.8824 10.2382 9.9473 11.25 9.6272V6.8259C8.7125 7.1938 6.75 9.3623 6.75 12C6.75 14.8945 9.1055 17.25 12 17.25C14.8945 17.25 17.25 14.8945 17.25 12C17.25 10.2503 16.3654 8.6744 15 7.7137V5.9802C17.2388 7.1017 18.75 9.4027 18.75 12C18.75 15.7217 15.7217 18.75 12 18.75C8.2783 18.75 5.25 15.7217 5.25 12C5.25 8.532 7.8803 5.6689 11.25 5.2943V2.788C6.4998 3.172 2.75 7.1526 2.75 12C2.75 17.1006 6.8994 21.25 12 21.25C17.1006 21.25 21.25 17.1006 21.25 12C21.25 8.0218 18.6808 4.5209 15 3.257V2C15 1.8866 14.9789 1.7791 14.9667 1.6689C19.5225 2.9763 22.75 7.1906 22.75 12Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProspectsIcon);
export default __webpack_public_path__ + "static/media/prospects-icon.58f0af8c4cfacbfd20047985f9aa52ae.svg";
export { ForwardRef as ReactComponent };